import styled from "styled-components";

const Map = styled.div`
    position: relative;
    width: 100%;
    height: 100%;
    min-height: 188px;
    background-color: var(--color-cloud);
`;

export default Map;
